/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Link as ThemeLink, LinkInterface } from '@lucid/gatsby-theme-lucid';
import { withTheme } from 'emotion-theming';
import { FC } from 'react';

import './link.scss';

const Link: FC<LinkInterface> = ({ rel = '', to = '', ...props }) => {
  const noFollow =
    to?.includes('/documents/') ||
    (to?.includes('/users/') && to?.includes('?'));

  return (
    <ThemeLink
      to={to}
      rel={`${noFollow ? 'nofollow ' : ''}${rel}`.trim() || undefined}
      blacklist={['documents', 'user', 'users', 'blog']}
      {...props}
    />
  );
};

export default withTheme(Link);
